// extracted by mini-css-extract-plugin
module.exports = {"fuel-grade-icon":"FuelGradeIcon_fuel-grade-icon__11i_f"};